import React, { useState, useRef, useEffect } from "react";
import "./chatbot.css";
import ReactMarkdown from "react-markdown";

// Speech-recognition imports REMOVED

const BACKEND_URL = "/api/ask-gemini";

function Chatbot({ isEmbedded = false }) {
  const [messages, setMessages] = useState([]);
  const [input, setInput] = useState("");
  const [isOpen, setIsOpen] = useState(isEmbedded); 
  const [chatHistory, setChatHistory] = useState([]);
  const messagesEndRef = useRef(null);

  // Speech-recognition hooks REMOVED

  // Speech-recognition useEffect REMOVED

  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  useEffect(() => {
    scrollToBottom();
  }, [messages]);

  const handleSendMessage = async (e) => {
    e.preventDefault();
    if (!input.trim()) return;

    const userMessage = { text: input, sender: "user" };
    setMessages((prev) => [...prev, userMessage]);

    const updatedHistory = [
      ...chatHistory,
      { role: "user", content: input },
    ];
    setChatHistory(updatedHistory);
    setInput("");
    // resetTranscript() REMOVED

    try {
      const response = await fetch(BACKEND_URL, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ question: input, history: updatedHistory }),
      });

      if (!response.ok) throw new Error("Network error");

      const data = await response.json();
      const aiMessage = { text: data.answer, sender: "ai" };
      setMessages((prev) => [...prev, aiMessage]);

      setChatHistory((prev) => [
        ...prev,
        { role: "assistant", content: data.answer },
      ]);
    } catch (error) {
      console.error("Failed to send message:", error);
      const errorMessage = {
        text: "⚠️ Under Maintenance. Try again later.",
        sender: "ai",
      };
      setMessages((prev) => [...prev, errorMessage]);
    }
  };

  // handleMicDown and handleMicUp functions REMOVED
  
  // browserSupportsSpeechRecognition check REMOVED

  return (
    <div className={`chatbot-wrapper ${isEmbedded ? "embedded" : ""}`}>
      
      {!isOpen && !isEmbedded && (
        <button className="chatbot-toggle" onClick={() => setIsOpen(true)}>
          <span>💬 Ask PrrepX Pathshala AI</span>
        </button>
      )}

      {isOpen && (
        <div className="chatbot-container animate-slide-in">
          <div className="chat-header">
            🤖 PrrepX Pathshala AI
            
            {!isEmbedded && (
              <button className="chat-close-btn" onClick={() => setIsOpen(false)}>
                ×
              </button>
            )}
          </div>

          <div className="chat-messages">
            {messages.length === 0 && (
              <div className="welcome-message">
                Welcome! 👋 Ask me any academic question.
              </div>
            )}
            {messages.map((msg, i) => (
              <div key={i} className={`message ${msg.sender}`}>
                {msg.sender === "ai" ? (
                  <ReactMarkdown>{msg.text}</ReactMarkdown>
                ) : (
                  msg.text
                )}
              </div>
            ))}
            <div ref={messagesEndRef} />
          </div>

          <form className="chat-input-form" onSubmit={handleSendMessage}>
            <input
              type="text"
              value={input}
              onChange={(e) => setInput(e.target.value)}
              placeholder="Type your question..." // Placeholder reverted
            />
            
            {/* Microphone button REMOVED */}

            <button type="submit">Send</button>
          </form>
        </div>
      )}
    </div>
  );
}

export default Chatbot;